"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tooltips = require("@vds-core/tooltips");
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _calculateTrackColor = function _calculateTrackColor(surface) {
  var trackColor;
  if (surface === "dark") {
    trackColor = "#333333";
  } else {
    trackColor = "#d8dada";
  }
  return trackColor;
};
var _calculateThumbColor = function _calculateThumbColor(surface, hover) {
  var thumbColor;
  if (surface === "dark" && !hover) {
    thumbColor = "#a7a7a7";
  } else if (hover && surface !== "dark") {
    thumbColor = "#333333";
  } else if (hover && surface === "dark") {
    thumbColor = "#d8dada";
  } else {
    thumbColor = "#6f7171";
  }
  return thumbColor;
};
var _getIconColor = function _getIconColor(iconFillColor, active, disabled, surface) {
  var iconColor;
  if (disabled && surface === "dark") {
    iconColor = "#333333";
  } else if (disabled && surface !== "dark") {
    iconColor = "#D8DADA";
  } else if (surface === "dark" && !disabled) {
    iconColor = "#FFFFFF";
  } else if (active) {
    iconColor = "#747676";
  } else {
    iconColor = "#000000";
  }
  return iconColor;
};
var propTypes = {
  /**
   * Renders inverted tooltip
   */
  inverted: _propTypes["default"].bool,
  /**
   * @ignore
   */
  surface: _propTypes["default"].oneOf(["light", "dark"]),
  /**
   * @deprecated
   * Function that returns an HTML element or React component to be used as a custom anchor for the tooltip
   */
  anchorElement: _propTypes["default"].func,
  /**
   * @deprecated
   * String, React Component, or HTML to rendered as the header of the tooltip
   */
  header: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  /**
   * @deprecated
   * For use with dark backgrounds, if true this changes the colors of this component to render its colors in reverse
   */
  secondary: _propTypes["default"].bool,
  /**
   * @ignore
   * Defaults to 'primary'
   */
  iconFillColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "brandHighlight"]), _propTypes["default"].string])
};
var defaultProps = {
  inverted: false
};
var Tooltip = function Tooltip(props) {
  var inverted = props.inverted,
    secondary = props.secondary;
  return /*#__PURE__*/_react["default"].createElement(_tooltips.Tooltip, (0, _extends2["default"])({}, props, {
    tooltipBorderRadius: "0",
    renderTooltipDialog: false // Brand 3.0 only. Default to Popover style
    ,
    renderAnchorElement: props.anchorElement || props.renderAnchorElement,
    title: props.header || props.title,
    inverted: secondary || inverted,
    surface: inverted ? "dark" : "light",
    dialogPadding: (0, _javascriptStyleHelpers.calculateRem)(12, 0, 12, 12),
    scrollbarBorderRadius: "0px",
    calculateThumbColor: _calculateThumbColor,
    calculateTrackColor: _calculateTrackColor,
    getIconColor: _getIconColor,
    tooltipIcon: true
  }));
};
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
var _default = exports["default"] = Tooltip;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/tooltips/dist/cjs/components/Tooltip.js
// module id = 1618
// module chunks = 0